import React from 'react';
import headerImage from '../content/yoga.JPG';
import Layout from './layout';
import HeroImage from '../components/HeroImage';
import EmailPostForm from '../components/EmailPostForm';

const Mailing = () => {
  return (
    <Layout>
      <HeroImage headerImage={headerImage} title='KEEP UP TO DATE'/>
      {/* Text Section */}
      <section className="flex-grow px-4 font-garet  py-10 bg-cream text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4">Join our mailing list</h2>
        <EmailPostForm/>
      </section>
    </Layout>
  );
};

export default Mailing;
